// import pokedex from "./pokedex";

const nameFix = {
  "deoxys-normal": "deoxys",
  "giratina-altered": "giratina",
  "mimikyu-disguised": "mimikyu",
  "aegislash-shield": "aegislash",
  "mime-jr": "mimejr",
  "mr-mime": "mrmime",
  "nidoran-m": "nidoranm",
  "nidoran-f": "nidoranf",
  "porygon-z": "porygonz",
  "ho-oh": "hooh",
  "ho-oh": "hoho",
  "ho-oh": "ohho",
  "ho-oh": "ohoh",
};

const typeFix = {
  1: ["grass"], // Bulbasaur
  2: ["grass"], // Ivysaur
  3: ["grass"], // Venusaur
  6: ["fire"], // Charizard
  74: ['rock'], // Geodude
  75: ['rock'], // Graveler
  76: ['rock'], // Golem
  81: ['steel', 'electric'], // Magnemite
  82: ['steel', 'electric'], // Magneton
  87: ["ice", "water"], // Dewgong
  92: ['ghost'], // Gastly
  93: ['ghost'], // Haunter
  94: ['ghost'], // Gengar
  95: ['rock'], // Onix
  123: ['bug'], // Scyther
  130: ['water'], // Gyarados
  138: ['water', 'rock'], // Omanyte
  139: ['water', 'rock'], // Omastar
  144: ['ice'], // Articuno
  145: ['electric'], // Zapdos
  146: ['fire'], // Moltres
  149: ['dragon'], // Dragonite
  208: ['steel'], // Steelix
  212: ['steel', 'bug'], // Scizor
  251: ['grass', 'psychic'], // Celebi
  263: ['steel', 'electric'], // Zigzagoon
  295: ['dark', 'ghost'], // Exploud
  324: ['steel', 'water'], // Torkoal
  364: ['steel', 'grass'], // Sealeo
}

const statFix = {
  12: { // Butterfree
    hp: 60,
    attack: 45,
    defense: 50,
    'special-attack': 80,
    'special-defense': 80,
    speed: 70
  },
  15: { // Beedrill
    hp: 65,
    attack: 80,
    defense: 40,
    'special-attack': 45,
    'special-defense': 80,
    speed: 75
  },
  18: { // Pidgeot
    hp: 83,
    attack: 80,
    defense: 75,
    'special-attack': 70,
    'special-defense': 70,
    speed: 91
  },
  24: { // Arbok
    hp: 60,
    attack: 85,
    defense: 69,
    'special-attack': 65,
    'special-defense': 79,
    speed: 80
  },
  25: { // Pikachu
    hp: 35,
    attack: 55,
    defense: 30,
    'special-attack': 50,
    'special-defense': 40,
    speed: 90
  },
  26: { // Raichu
    hp: 60,
    attack: 90,
    defense: 55,
    'special-attack': 90,
    'special-defense': 80,
    speed: 100
  },
  31: { // Nidoqueen
    hp: 90,
    attack: 82,
    defense: 87,
    'special-attack': 75,
    'special-defense': 85,
    speed: 76
  },
  34: { // Nidoking
    hp: 81,
    attack: 92,
    defense: 77,
    'special-attack': 85,
    'special-defense': 75,
    speed: 85
  },
  36: { // Clefable
    hp: 95,
    attack: 70,
    defense: 73,
    'special-attack': 85,
    'special-defense': 90,
    speed: 60
  },
  40: { // Wigglytuff
    hp: 140,
    attack: 70,
    defense: 45,
    'special-attack': 75,
    'special-defense': 50,
    speed: 45
  },
  45: { // Vileplume
    hp: 75,
    attack: 80,
    defense: 85,
    'special-attack': 100,
    'special-defense': 90,
    speed: 50
  },
  51: { // Dugtrio
    hp: 35,
    attack: 80,
    defense: 50,
    'special-attack': 50,
    'special-defense': 70,
    speed: 120
  },
  62: { // Poliwrath
    hp: 90,
    attack: 85,
    defense: 95,
    'special-attack': 70,
    'special-defense': 90,
    speed: 70
  },
  65: { // Alakazam
    hp: 55,
    attack: 50,
    defense: 45,
    'special-attack': 135,
    'special-defense': 85,
    speed: 120
  },
  71: { // Victreebel
    hp: 80,
    attack: 105,
    defense: 65,
    'special-attack': 100,
    'special-defense': 60,
    speed: 70
  },
  76: { // Golem
    hp: 80,
    attack: 110,
    defense: 130,
    'special-attack': 55,
    'special-defense': 65,
    speed: 45
  },
  83: { // Farfetchd
    hp: 52,
    attack: 65,
    defense: 55,
    'special-attack': 58,
    'special-defense': 62,
    speed: 60
  },
  85: { // Dodrio
    hp: 60,
    attack: 110,
    defense: 70,
    'special-attack': 60,
    'special-defense': 60,
    speed: 100
  },
  103: { // Exeggutor
    hp: 95,
    attack: 95,
    defense: 85,
    'special-attack': 125,
    'special-defense': 65,
    speed: 55
  },
  101: { // Electrode
    hp: 60,
    attack: 50,
    defense: 70,
    'special-attack': 80,
    'special-defense': 80,
    speed: 140
  },
  164: { // Noctowl
    hp: 100,
    attack: 50,
    defense: 50,
    'special-attack': 76,
    'special-defense': 96,
    speed: 70
  },
  168: { // Ariados
    hp: 70,
    attack: 90,
    defense: 70,
    'special-attack': 60,
    'special-defense': 60,
    speed: 40
  },
  181: { // Ampharos
    hp: 90,
    attack: 75,
    defense: 75,
    'special-attack': 115,
    'special-defense': 90,
    speed: 55
  },
  182: { // Bellossom
    hp: 75,
    attack: 80,
    defense: 85,
    'special-attack': 90,
    'special-defense': 100,
    speed: 50
  },
  184: { // Azumarill
    hp: 100,
    attack: 50,
    defense: 80,
    'special-attack': 50,
    'special-defense': 80,
    speed: 50
  },
  189: { // Jumpluff
    hp: 75,
    attack: 55,
    defense: 70,
    'special-attack': 55,
    'special-defense': 85,
    speed: 110
  },
  211: { // Qwilfish
    hp: 65,
    attack: 95,
    defense: 75,
    'special-attack': 55,
    'special-defense': 55,
    speed: 85
  },
  219: { // Magcargo
    hp: 50,
    attack: 50,
    defense: 120,
    'special-attack': 80,
    'special-defense': 80,
    speed: 30
  },
  222: { // Corsola
    hp: 55,
    attack: 55,
    defense: 85,
    'special-attack': 65,
    'special-defense': 85,
    speed: 35
  },
  226: { // Mantine
    hp: 65,
    attack: 40,
    defense: 70,
    'special-attack': 80,
    'special-defense': 140,
    speed: 70
  },
  329: { // Aegislash
    hp: 60,
    attack: 50,
    defense: 150,
    'special-attack': 50,
    'special-defense': 150,
    speed: 60
  },
  352: { // Roserade
    hp: 60,
    attack: 70,
    defense: 55,
    'special-attack': 125,
    'special-defense': 105,
    speed: 90
  },
  361: { // Krookodile
    hp: 95,
    attack: 117,
    defense: 70,
    'special-attack': 65,
    'special-defense': 70,
    speed: 92
  },
}

const abilityIDMap = {
  "stench": 1,
  "drizzle": 2,
  "speed-boost": 3,
  "battle-armor": 4,
  "sturdy": 5,
  "damp": 6,
  "limber": 7,
  "sand-veil": 8,
  "static": 9,
  "volt-absorb": 10,
  "water-absorb": 11,
  "oblivious": 12,
  "cloud-nine": 13,
  "compound-eyes": 14,
  "insomnia": 15,
  "color-change": 16,
  "immunity": 17,
  "flash-fire": 18,
  "shield-dust": 19,
  "own-tempo": 20,
  "suction-cups": 21,
  "intimidate": 22,
  "shadow-tag": 23,
  "rough-skin": 24,
  "wonder-guard": 25,
  "levitate": 26,
  "effect-spore": 27,
  "synchronize": 28,
  "clear-body": 29,
  "natural-cure": 30,
  "lightning-rod": 31,
  "serene-grace": 32,
  "swift-swim": 33,
  "chlorophyll": 34,
  "illuminate": 35,
  "trace": 36,
  "huge-power": 37,
  "poison-point": 38,
  "inner-focus": 39,
  "magma-armor": 40,
  "water-veil": 41,
  "magnet-pull": 42,
  "soundproof": 43,
  "rain-dish": 44,
  "sand-stream": 45,
  "pressure": 46,
  "thick-fat": 47,
  "early-bird": 48,
  "flame-body": 49,
  "run-away": 50,
  "keen-eye": 51,
  "hyper-cutter": 52,
  "pickup": 53,
  "truant": 54,
  "hustle": 55,
  "cute-charm": 56,
  "plus": 57,
  "minus": 58,
  "forecast": 59,
  "sticky-hold": 60,
  "shed-skin": 61,
  "guts": 62,
  "marvel-scale": 63,
  "liquid-ooze": 64,
  "overgrow": 65,
  "blaze": 66,
  "torrent": 67,
  "swarm": 68,
  "rock-head": 69,
  "drought": 70,
  "arena-trap": 71,
  "vital-spirit": 72,
  "white-smoke": 73,
  "pure-power": 74,
  "shell-armor": 75,
  "air-lock": 76,
  "tangled-feet": 77,
  "motor-drive": 78,
  "rivalry": 79,
  "steadfast": 80,
  "snow-cloak": 81,
  "gluttony": 82,
  "anger-point": 83,
  "unburden": 84,
  "heatproof": 85,
  "simple": 86,
  "dry-skin": 87,
  "download": 88,
  "iron-fist": 89,
  "poison-heal": 90,
  "adaptability": 91,
  "skill-link": 92,
  "hydration": 93,
  "solar-power": 94,
  "quick-feet": 95,
  "normalize": 96,
  "sniper": 97,
  "magic-guard": 98,
  "no-guard": 99,
  "stall": 100,
  "technician": 101,
  "leaf-guard": 102,
  "klutz": 103,
  "mold-breaker": 104,
  "super-luck": 105,
  "aftermath": 106,
  "anticipation": 107,
  "forewarn": 108,
  "unaware": 109,
  "tinted-lens": 110,
  "filter": 111,
  "slow-start": 112,
  "scrappy": 113,
  "storm-drain": 114,
  "ice-body": 115,
  "solid-rock": 116,
  "snow-warning": 117,
  "honey-gather": 118,
  "frisk": 119,
  "reckless": 120,
  "multitype": 121,
  "flower-gift": 122,
  "bad-dreams": 123,
  "pickpocket": 124,
  "sheer-force": 125,
  "contrary": 126,
  "unnerve": 127,
  "defiant": 128,
  "defeatist": 129,
  "cursed-body": 130,
  "healer": 131,
  "friend-guard": 132,
  "weak-armor": 133,
  "heavy-metal": 134,
  "light-metal": 135,
  "multiscale": 136,
  "toxic-boost": 137,
  "flare-boost": 138,
  "harvest": 139,
  "telepathy": 140,
  "moody": 141,
  "overcoat": 142,
  "poison-touch": 143,
  "regenerator": 144,
  "big-pecks": 145,
  "sand-rush": 146,
  "wonder-skin": 147,
  "analytic": 148,
  "illusion": 149,
  "imposter": 150,
  "infiltrator": 151,
  "mummy": 152,
  "moxie": 153,
  "justified": 154,
  "rattled": 155,
  "magic-bounce": 156,
  "sap-sipper": 157,
  "prankster": 158,
  "sand-force": 159,
  "iron-barbs": 160,
  "zen-mode": 161,
  "victory-star": 162,
  "turboblaze": 163,
  "teravolt": 164,
  "aroma-veil": 165,
  "flower-veil": 166,
  "cheek-pouch": 167,
  "protean": 168,
  "fur-coat": 169,
  "magician": 170,
  "bulletproof": 171,
  "competitive": 172,
  "strong-jaw": 173,
  "refrigerate": 174,
  "sweet-veil": 175,
  "stance-change": 176,
  "gale-wings": 177,
  "mega-launcher": 178,
  "grass-pelt": 179,
  "symbiosis": 180,
  "tough-claws": 181,
  "pixilate": 182,
  "gooey": 183,
  "aerilate": 184,
  "parental-bond": 185,
  "dark-aura": 186,
  "fairy-aura": 187,
  "aura-break": 188,
  "primordial-sea": 189,
  "desolate-land": 190,
  "delta-stream": 191,
  "stamina": 192,
  "wimp-out": 193,
  "emergency-exit": 194,
  "water-compaction": 195,
  "merciless": 196,
  "shields-down": 197,
  "stakeout": 198,
  "water-bubble": 199,
  "steelworker": 200,
  "berserk": 201,
  "slush-rush": 202,
  "long-reach": 203,
  "liquid-voice": 204,
  "triage": 205,
  "galvanize": 206,
  "surge-surfer": 207,
  "schooling": 208,
  "disguise": 209,
  "battle-bond": 210,
  "power-construct": 211,
  "corrosion": 212,
  "comatose": 213,
  "queenly-majesty": 214,
  "innards-out": 215,
  "dancer": 216,
  "battery": 217,
  "fluffy": 218,
  "dazzling": 219,
  "soul-heart": 220,
  "tangling-hair": 221,
  "receiver": 222,
  "power-of-alchemy": 223,
  "beast-boost": 224,
  "rks-system": 225,
  "electric-surge": 226,
  "psychic-surge": 227,
  "misty-surge": 228,
  "grassy-surge": 229,
  "full-metal-body": 230,
  "shadow-shield": 231,
  "prism-armor": 232,
  "neuroforce": 233,
  "intrepid-sword": 234,
  "dauntless-shield": 235,
  "libero": 236,
  "ball-fetch": 237,
  "cotton-down": 238,
  "propeller-tail": 239,
  "mirror-armor": 240,
  "gulp-missile": 241,
  "stalwart": 242,
  "steam-engine": 243,
  "punk-rock": 244,
  "sand-spit": 245,
  "ice-scales": 246,
  "ripen": 247,
  "ice-face": 248,
  "power-spot": 249,
  "mimicry": 250,
  "screen-cleaner": 251,
  "steely-spirit": 252,
  "perish-body": 253,
  "wandering-spirit": 254,
  "gorilla-tactics": 255,
  "neutralizing-gas": 256,
  "pastel-veil": 257,
  "hunger-switch": 258,
  "quick-draw": 259,
  "unseen-fist": 260,
  "curious-medicine": 261,
  "transistor": 262,
  "dragons-maw": 263,
  "chilling-neigh": 264,
  "grim-neigh": 265,
  "as-one-glastrier": 266,
  "as-one-spectrier": 267,
  "mountaineer": 10001,
  "wave-rider": 10002,
  "skater": 10003,
  "thrust": 10004,
  "perception": 10005,
  "parry": 10006,
  "instinct": 10007,
  "dodge": 10008,
  "jagged-edge": 10009,
  "frostbite": 10010,
  "tenacity": 10011,
  "pride": 10012,
  "deep-sleep": 10013,
  "power-nap": 10014,
  "spirit": 10015,
  "warm-blanket": 10016,
  "gulp": 10017,
  "herbivore": 10018,
  "sandpit": 10019,
  "hot-blooded": 10020,
  "medic": 10021,
  "life-force": 10022,
  "lunchbox": 10023,
  "nurse": 10024,
  "melee": 10025,
  "sponge": 10026,
  "bodyguard": 10027,
  "hero": 10028,
  "last-bastion": 10029,
  "stealth": 10030,
  "vanguard": 10031,
  "nomad": 10032,
  "sequence": 10033,
  "grass-cloak": 10034,
  "celebrate": 10035,
  "lullaby": 10036,
  "calming": 10037,
  "daze": 10038,
  "frighten": 10039,
  "interference": 10040,
  "mood-maker": 10041,
  "confidence": 10042,
  "fortune": 10043,
  "bonanza": 10044,
  "explode": 10045,
  "omnipotent": 10046,
  "share": 10047,
  "black-hole": 10048,
  "shadow-dash": 10049,
  "sprint": 10050,
  "disgust": 10051,
  "high-rise": 10052,
  "climber": 10053,
  "flame-boost": 10054,
  "aqua-boost": 10055,
  "run-up": 10056,
  "conqueror": 10057,
  "shackle": 10058,
  "decoy": 10059,
  "shield": 10060,
};

const abilitySwap = {
  16: true,
  17: true,
  18: true,
  23: true,
  24: true,
  50: true,
  51: true,
  58: true,
  59: true,
  66: true,
  67: true,
  68: true,
  74: true,
  75: true,
  76: true,
  83: true,
  95: true,
  208: true,
  98: true,
  99: true,
  100: true,
  101: true,
  104: true,
  105: true,
  107: true,
  131: true,
  143: true,
  142: true,
  170: true,
  171: true,
  183: true,
  184: true,
  206: true,
  198: true,
  256: true,
  209: true,
  210: true,
  216: true,
  217: true,
  310: true,
};

const abilityFix = {};
function populateAbilityFix(){
  abilityFix[35] = [ // Clefairy
    {
      "ability": {
          "name": "magic-guard"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "cute-charm"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "friend-guard",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[36] = [ // Clefable
    {
      "ability": {
          "name": "magic guard"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "cute charm"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "unaware",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[39] = [ // Jigglypuff
    {
      "ability": {
          "name": "cute-charm"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "friend-guard",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[40] = [ // Wigglytuff
    {
        "ability": {
            "name": "cute-charm"
        },
        "is_hidden": false,
    },
    {
        "ability": {
            "name": "frisk",
        },
        "is_hidden": true,
    }
  ];
  abilityFix[94] = [ // Gengar
    {
      "ability": {
          "name": "levitate"
      },
      "is_hidden": false,
    },
  ];
  abilityFix[109] = [ // Koffing
    {
      "ability": {
          "name": "levitate"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "stench",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[110] = abilityFix[109]; // Weezing
  abilityFix[145] = [ // Zapdos
    {
      "ability": {
          "name": "pressure"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "lightning-rod",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[150] = [ // Mewtwo
    {
      "ability": {
          "name": "pressure"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "immunity",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[173] = abilityFix[35]; // Cleffa
  abilityFix[174] = abilityFix[39]; // Igglybuff
  abilityFix[201] = [ // Unown
    {
      "ability": {
          "name": "levitate"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "mummy",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[243] = [ // Raikou
    {
      "ability": {
          "name": "pressure"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "volt-absorb",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[244] = [ // Entei
    {
      "ability": {
          "name": "pressure"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "flash-fire",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[245] = [ // Suicune
    {
      "ability": {
          "name": "pressure"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "water-absorb",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[334] = [ // Flygon
    {
      "ability": {
          "name": "levitate"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "dry-skin",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[335] = [ // Milotic
    {
      "ability": {
        "name": "marvel-scale"
      },
      "is_hidden": false,
    },
    {
      "ability": {
        "name": "cute-charm",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[346] = [ // Regigigas
    {
      "ability": {
          "name": "slow-start"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "mold-breaker",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[347] = [ // Darkrai
    {
      "ability": {
          "name": "bad-dreams"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "white-smoke",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[348] = [ // Genesect
    {
      "ability": {
          "name": "download"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "motor-drive",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[349] = [ // Reshiram
    {
      "ability": {
          "name": "turboblaze"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "flare-boost",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[350] = [ // Zekrom
    {
      "ability": {
          "name": "teravolt"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "volt-absorb",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[351] = [ // Kyurem
    {
      "ability": {
          "name": "pressure"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "ice-body",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[364] = [ // Ferrothorn
    {
      "ability": {
          "name": "iron-barbs"
      },
      "is_hidden": false,
    }
  ];
  abilityFix[365] = [ //Litwick
    {
        "ability": {
          "name": "flash-fire"
        },
        "is_hidden": false,
    },
    {
    "ability": {
        "name": "flame-body",
      },
      "is_hidden": false,
    },
    {
      "ability": {
        "name": "shadow-tag",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[366] = abilityFix[365]; //Lampent
  abilityFix[367] = abilityFix[365]; //Chandelure
  abilityFix[372] = [ // Talonflame
    {
      "ability": {
          "name": "big-pecks"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "gale-wings",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[377] = [ // Hydreigon
    {
      "ability": {
          "name": "levitate"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "hustle",
      },
      "is_hidden": true,
    }
  ];
  abilityFix[394] = [ // Feebas
    {
      "ability": {
          "name": "swift-swim"
      },
      "is_hidden": false,
    },
    {
      "ability": {
          "name": "adaptability",
      },
      "is_hidden": true,
    }
  ];
}
populateAbilityFix();

const pokemonGameIDFromName = {
  "bulbasaur": 1,
  "ivysaur": 2,
  "venusaur": 3,
  "charmander": 4,
  "charmeleon": 5,
  "charizard": 6,
  "squirtle": 7,
  "wartortle": 8,
  "blastoise": 9,
  "caterpie": 10,
  "metapod": 11,
  "butterfree": 12,
  "weedle": 13,
  "kakuna": 14,
  "beedrill": 15,
  "pidgey": 16,
  "pidgeotto": 17,
  "pidgeot": 18,
  "rattata": 19,
  "raticate": 20,
  "spearow": 21,
  "fearow": 22,
  "ekans": 23,
  "arbok": 24,
  "pikachu": 25,
  "raichu": 26,
  "sandshrew": 27,
  "sandslash": 28,
  "nidoran-f": 29,
  "nidorina": 30,
  "nidoqueen": 31,
  "nidoran-m": 32,
  "nidorino": 33,
  "nidoking": 34,
  "clefairy": 35,
  "clefable": 36,
  "vulpix": 37,
  "ninetales": 38,
  "jigglypuff": 39,
  "wigglytuff": 40,
  "zubat": 41,
  "golbat": 42,
  "oddish": 43,
  "gloom": 44,
  "vileplume": 45,
  "paras": 46,
  "parasect": 47,
  "venonat": 48,
  "venomoth": 49,
  "diglett": 50,
  "dugtrio": 51,
  "meowth": 52,
  "persian": 53,
  "psyduck": 54,
  "golduck": 55,
  "mankey": 56,
  "primeape": 57,
  "growlithe": 58,
  "arcanine": 59,
  "poliwag": 60,
  "poliwhirl": 61,
  "poliwrath": 62,
  "abra": 63,
  "kadabra": 64,
  "alakazam": 65,
  "machop": 66,
  "machoke": 67,
  "machamp": 68,
  "bellsprout": 69,
  "weepinbell": 70,
  "victreebel": 71,
  "tentacool": 72,
  "tentacruel": 73,
  "geodude": 74,
  "graveler": 75,
  "golem": 76,
  "ponyta": 77,
  "rapidash": 78,
  "slowpoke": 79,
  "slowbro": 80,
  "magnemite": 81,
  "magneton": 82,
  "farfetchd": 83,
  "doduo": 84,
  "dodrio": 85,
  "seel": 86,
  "dewgong": 87,
  "grimer": 88,
  "muk": 89,
  "shellder": 90,
  "cloyster": 91,
  "gastly": 92,
  "haunter": 93,
  "gengar": 94,
  "onix": 95,
  "drowzee": 96,
  "hypno": 97,
  "krabby": 98,
  "kingler": 99,
  "voltorb": 100,
  "electrode": 101,
  "exeggcute": 102,
  "exeggutor": 103,
  "cubone": 104,
  "marowak": 105,
  "hitmonlee": 106,
  "hitmonchan": 107,
  "lickitung": 108,
  "koffing": 109,
  "weezing": 110,
  "rhyhorn": 111,
  "rhydon": 112,
  "chansey": 113,
  "tangela": 114,
  "kangaskhan": 115,
  "horsea": 116,
  "seadra": 117,
  "goldeen": 118,
  "seaking": 119,
  "staryu": 120,
  "starmie": 121,
  "mr-mime": 122,
  "scyther": 123,
  "jynx": 124,
  "electabuzz": 125,
  "magmar": 126,
  "pinsir": 127,
  "tauros": 128,
  "magikarp": 129,
  "gyarados": 130,
  "lapras": 131,
  "ditto": 132,
  "eevee": 133,
  "vaporeon": 134,
  "jolteon": 135,
  "flareon": 136,
  "porygon": 137,
  "omanyte": 138,
  "omastar": 139,
  "kabuto": 140,
  "kabutops": 141,
  "aerodactyl": 142,
  "snorlax": 143,
  "articuno": 144,
  "zapdos": 145,
  "moltres": 146,
  "dratini": 147,
  "dragonair": 148,
  "dragonite": 149,
  "mewtwo": 150,
  "mew": 151,
  "chikorita": 152,
  "bayleef": 153,
  "meganium": 154,
  "cyndaquil": 155,
  "quilava": 156,
  "typhlosion": 157,
  "totodile": 158,
  "croconaw": 159,
  "feraligatr": 160,
  "sentret": 161,
  "furret": 162,
  "hoothoot": 163,
  "noctowl": 164,
  "ledyba": 165,
  "ledian": 166,
  "spinarak": 167,
  "ariados": 168,
  "crobat": 169,
  "chinchou": 170,
  "lanturn": 171,
  "pichu": 172,
  "cleffa": 173,
  "igglybuff": 174,
  "togepi": 175,
  "togetic": 176,
  "natu": 177,
  "xatu": 178,
  "mareep": 179,
  "flaaffy": 180,
  "ampharos": 181,
  "bellossom": 182,
  "marill": 183,
  "azumarill": 184,
  "sudowoodo": 185,
  "politoed": 186,
  "hoppip": 187,
  "skiploom": 188,
  "jumpluff": 189,
  "aipom": 190,
  "sunkern": 191,
  "sunflora": 192,
  "yanma": 193,
  "wooper": 194,
  "quagsire": 195,
  "espeon": 196,
  "umbreon": 197,
  "murkrow": 198,
  "slowking": 199,
  "misdreavus": 200,
  "unown": 201,
  "wobbuffet": 202,
  "girafarig": 203,
  "pineco": 204,
  "forretress": 205,
  "dunsparce": 206,
  "gligar": 207,
  "steelix": 208,
  "snubbull": 209,
  "granbull": 210,
  "qwilfish": 211,
  "scizor": 212,
  "shuckle": 213,
  "heracross": 214,
  "sneasel": 215,
  "teddiursa": 216,
  "ursaring": 217,
  "slugma": 218,
  "magcargo": 219,
  "swinub": 220,
  "piloswine": 221,
  "corsola": 222,
  "remoraid": 223,
  "octillery": 224,
  "delibird": 225,
  "mantine": 226,
  "skarmory": 227,
  "houndour": 228,
  "houndoom": 229,
  "kingdra": 230,
  "phanpy": 231,
  "donphan": 232,
  "porygon2": 233,
  "stantler": 234,
  "smeargle": 235,
  "tyrogue": 236,
  "hitmontop": 237,
  "smoochum": 238,
  "elekid": 239,
  "magby": 240,
  "miltank": 241,
  "blissey": 242,
  "raikou": 243,
  "entei": 244,
  "suicune": 245,
  "larvitar": 246,
  "pupitar": 247,
  "tyranitar": 248,
  "lugia": 249,
  "ho-oh": 250,
  "celebi": 251,
  "azurill": 252,
  "wynaut": 253,
  "ambipom": 254,
  "mismagius": 255,
  "honchkrow": 256,
  "bonsly": 257,
  "mime-jr": 258,
  "happiny": 259,
  "munchlax": 260,
  "mantyke": 261,
  "weavile": 262,
  "magnezone": 263,
  "lickilicky": 264,
  "rhyperior": 265,
  "tangrowth": 266,
  "electivire": 267,
  "magmortar": 268,
  "togekiss": 269,
  "yanmega": 270,
  "leafeon": 271,
  "glaceon": 272,
  "gliscor": 273,
  "mamoswine": 274,
  "porygon-z": 275,
  "treecko": 276,
  "grovyle": 277,
  "sceptile": 278,
  "torchic": 279,
  "combusken": 280,
  "blaziken": 281,
  "mudkip": 282,
  "marshtomp": 283,
  "swampert": 284,
  "ralts": 285,
  "kirlia": 286,
  "gardevoir": 287,
  "gallade": 288,
  "shedinja": 289,
  "kecleon": 290,
  "beldum": 291,
  "metang": 292,
  "metagross": 293,
  "bidoof": 294,
  "spiritomb": 295,
  "lucario": 296,
  "gible": 297,
  "gabite": 298,
  "garchomp": 299,
  "mawile": 300,
  "lileep": 301,
  "cradily": 302,
  "anorith": 303,
  "armaldo": 304,
  "cranidos": 305,
  "rampardos": 306,
  "shieldon": 307,
  "bastiodon": 308,
  "slaking": 309,
  "absol": 310,
  "duskull": 311,
  "dusclops": 312,
  "dusknoir": 313,
  "wailord": 314,
  "arceus": 315,
  "turtwig": 316,
  "grotle": 317,
  "torterra": 318,
  "chimchar": 319,
  "monferno": 320,
  "infernape": 321,
  "piplup": 322,
  "prinplup": 323,
  "empoleon": 324,
  "nosepass": 325,
  "probopass": 326,
  "honedge": 327,
  "doublade": 328,
  "aegislash": 329,
  "pawniard": 330,
  "bisharp": 331,
  "luxray": 332,
  "aggron": 333,
  "flygon": 334,
  "milotic": 335,
  "salamence": 336,
  "klinklang": 337,
  "zoroark": 338,
  "sylveon": 339,
  "kyogre": 340,
  "groudon": 341,
  "rayquaza": 342,
  "dialga": 343,
  "palkia": 344,
  "giratina": 345,
  "regigigas": 346,
  "darkrai": 347,
  "genesect": 348,
  "reshiram": 349,
  "zekrom": 350,
  "kyurem": 351,
  "roserade": 352,
  "drifblim": 353,
  "lopunny": 354,
  "breloom": 355,
  "ninjask": 356,
  "banette": 357,
  "rotom": 358,
  "reuniclus": 359,
  "whimsicott": 360,
  "krookodile": 361,
  "cofagrigus": 362,
  "galvantula": 363,
  "ferrothorn": 364,
  "litwick": 365,
  "lampent": 366,
  "chandelure": 367,
  "haxorus": 368,
  "golurk": 369,
  "pyukumuku": 370,
  "klefki": 371,
  "talonflame": 372,
  "mimikyu": 373,
  "volcarona": 374,
  "deino": 375,
  "zweilous": 376,
  "hydreigon": 377,
  "latias": 378,
  "latios": 379,
  "deoxys": 380,
  "jirachi": 381,
  "nincada": 382,
  "bibarel": 383,
  "riolu": 384,
  "slakoth": 385,
  "vigoroth": 386,
  "wailmer": 387,
  "shinx": 388,
  "luxio": 389,
  "aron": 390,
  "lairon": 391,
  "trapinch": 392,
  "vibrava": 393,
  "feebas": 394,
  "bagon": 395,
  "shelgon": 396,
  "klink": 397,
  "klang": 398,
  "zorua": 399,
  "budew": 400,
  "roselia": 401,
  "drifloon": 402,
  "buneary": 403,
  "shroomish": 404,
  "shuppet": 405,
  "solosis": 406,
  "duosion": 407,
  "cottonee": 408,
  "sandile": 409,
  "krokorok": 410,
  "yamask": 411,
  "joltik": 412,
  "ferroseed": 413,
  "axew": 414,
  "fraxure": 415,
  "golett": 416,
  "fletchling": 417,
  "fletchinder": 418,
  "larvesta": 419,
  "stunfisk": 420,
};

const gameIDRemap = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  10: 10,
  11: 11,
  12: 12,
  13: 13,
  14: 14,
  15: 15,
  16: 16,
  17: 17,
  18: 18,
  19: 19,
  20: 20,
  21: 21,
  22: 22,
  23: 23,
  24: 24,
  25: 25,
  26: 26,
  27: 27,
  28: 28,
  29: 29,
  30: 30,
  31: 31,
  32: 32,
  33: 33,
  34: 34,
  35: 35,
  36: 36,
  37: 37,
  38: 38,
  39: 39,
  40: 40,
  41: 41,
  42: 42,
  43: 43,
  44: 44,
  45: 45,
  46: 46,
  47: 47,
  48: 48,
  49: 49,
  50: 50,
  51: 51,
  52: 52,
  53: 53,
  54: 54,
  55: 55,
  56: 56,
  57: 57,
  58: 58,
  59: 59,
  60: 60,
  61: 61,
  62: 62,
  63: 63,
  64: 64,
  65: 65,
  66: 66,
  67: 67,
  68: 68,
  69: 69,
  70: 70,
  71: 71,
  72: 72,
  73: 73,
  74: 74,
  75: 75,
  76: 76,
  77: 77,
  78: 78,
  79: 79,
  80: 80,
  81: 81,
  82: 82,
  83: 83,
  84: 84,
  85: 85,
  86: 86,
  87: 87,
  88: 88,
  89: 89,
  90: 90,
  91: 91,
  92: 92,
  93: 93,
  94: 94,
  95: 95,
  96: 96,
  97: 97,
  98: 98,
  99: 99,
  100: 100,
  101: 101,
  102: 102,
  103: 103,
  104: 104,
  105: 105,
  106: 106,
  107: 107,
  108: 108,
  109: 109,
  110: 110,
  111: 111,
  112: 112,
  113: 113,
  114: 114,
  115: 115,
  116: 116,
  117: 117,
  118: 118,
  119: 119,
  120: 120,
  121: 121,
  122: 122,
  123: 123,
  124: 124,
  125: 125,
  126: 126,
  127: 127,
  128: 128,
  129: 129,
  130: 130,
  131: 131,
  132: 132,
  133: 133,
  134: 134,
  135: 135,
  136: 136,
  137: 137,
  138: 138,
  139: 139,
  140: 140,
  141: 141,
  142: 142,
  143: 143,
  144: 144,
  145: 145,
  146: 146,
  147: 147,
  148: 148,
  149: 149,
  150: 150,
  151: 151,
  152: 152,
  153: 153,
  154: 154,
  155: 155,
  156: 156,
  157: 157,
  158: 158,
  159: 159,
  160: 160,
  161: 161,
  162: 162,
  163: 163,
  164: 164,
  165: 165,
  166: 166,
  167: 167,
  168: 168,
  169: 169,
  170: 170,
  171: 171,
  172: 172,
  173: 173,
  174: 174,
  175: 175,
  176: 176,
  177: 177,
  178: 178,
  179: 179,
  180: 180,
  181: 181,
  182: 182,
  183: 183,
  184: 184,
  185: 185,
  186: 186,
  187: 187,
  188: 188,
  189: 189,
  190: 190,
  191: 191,
  192: 192,
  193: 193,
  194: 194,
  195: 195,
  196: 196,
  197: 197,
  198: 198,
  199: 199,
  200: 200,
  201: 201,
  202: 202,
  203: 203,
  204: 204,
  205: 205,
  206: 206,
  207: 207,
  208: 208,
  209: 209,
  210: 210,
  211: 211,
  212: 212,
  213: 213,
  214: 214,
  215: 215,
  216: 216,
  217: 217,
  218: 218,
  219: 219,
  220: 220,
  221: 221,
  222: 222,
  223: 223,
  224: 224,
  225: 225,
  226: 226,
  227: 227,
  228: 228,
  229: 229,
  230: 230,
  231: 231,
  232: 232,
  233: 233,
  234: 234,
  235: 235,
  236: 236,
  237: 237,
  238: 238,
  239: 239,
  240: 240,
  241: 241,
  242: 242,
  243: 243,
  244: 244,
  245: 245,
  246: 246,
  247: 247,
  248: 248,
  249: 249,
  250: 250,
  251: 251,
  252: 276,
  253: 277,
  254: 278,
  255: 279,
  256: 280,
  257: 281,
  258: 282,
  259: 283,
  260: 284,
  280: 285,
  281: 286,
  282: 287,
  285: 404,
  286: 355,
  287: 385,
  288: 386,
  289: 309,
  290: 382,
  291: 356,
  292: 289,
  298: 252,
  299: 325,
  303: 300,
  304: 390,
  305: 391,
  306: 333,
  315: 401,
  320: 387,
  321: 314,
  328: 392,
  329: 393,
  330: 334,
  345: 301,
  346: 302,
  347: 303,
  348: 304,
  349: 394,
  350: 335,
  352: 290,
  353: 405,
  354: 357,
  355: 311,
  356: 312,
  359: 310,
  360: 253,
  371: 395,
  372: 396,
  373: 336,
  374: 291,
  375: 292,
  376: 293,
  380: 378,
  381: 379,
  382: 340,
  383: 341,
  384: 342,
  385: 381,
  386: 380,
  387: 316,
  388: 317,
  389: 318,
  390: 319,
  391: 320,
  392: 321,
  393: 322,
  394: 323,
  395: 324,
  399: 294,
  400: 383,
  403: 388,
  404: 389,
  405: 332,
  406: 400,
  407: 352,
  408: 305,
  409: 306,
  410: 307,
  411: 308,
  424: 254,
  425: 402,
  426: 353,
  427: 403,
  428: 354,
  429: 255,
  430: 256,
  438: 257,
  439: 258,
  440: 259,
  442: 295,
  443: 297,
  444: 298,
  445: 299,
  446: 260,
  447: 384,
  448: 296,
  458: 261,
  461: 262,
  462: 263,
  463: 264,
  464: 265,
  465: 266,
  466: 267,
  467: 268,
  468: 269,
  469: 270,
  470: 271,
  471: 272,
  472: 273,
  473: 274,
  474: 275,
  475: 288,
  476: 326,
  477: 313,
  479: 358,
  483: 343,
  484: 344,
  486: 346,
  487: 345,
  491: 347,
  493: 315,
  546: 408,
  547: 360,
  551: 409,
  552: 410,
  553: 361,
  562: 411,
  563: 362,
  570: 399,
  571: 338,
  577: 406,
  578: 407,
  579: 359,
  595: 412,
  596: 363,
  597: 413,
  598: 364,
  599: 397,
  600: 398,
  601: 337,
  607: 365,
  608: 366,
  609: 367,
  610: 414,
  611: 415,
  612: 368,
  618: 420,
  622: 416,
  623: 369,
  624: 330,
  625: 331,
  633: 375,
  634: 376,
  635: 377,
  636: 419,
  637: 374,
  643: 349,
  644: 350,
  646: 351,
  649: 348,
  661: 417,
  662: 418,
  663: 372,
  679: 327,
  680: 328,
  681: 329,
  700: 339,
  707: 371,
  771: 370,
  778: 373,
}

// async function bro(){
//   let s = '{\n';
//   abilitySwap.forEach((e) => {
//     s += `${pokemonGameIDFromName[e]}: true,\n`;
//   });
//   s += '};';
//   console.log(s);
// }
// bro();

export default {
  nameFix,
  gameIDRemap,
  pokemonGameIDFromName,
  typeFix,
  abilityIDMap,
  abilityFix,
  abilitySwap,
  statFix
};